interface TimeRemaining {
  hours: number
  minutes: number
  seconds: number
  days: number
}

export function getTimeRemaining(endtime: Date): TimeRemaining {
  const total = endtime.getTime() - new Date().getTime()
  const seconds = Math.floor((total / 1000) % 60)
  const minutes = Math.floor((total / 1000 / 60) % 60)
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24)
  const days = Math.floor(total / (1000 * 60 * 60 * 24))

  return {
    days,
    hours,
    minutes,
    seconds,
  }
}

export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export function getDateWithTimeZone({
  timeZone,
  year,
  month,
  day,
  hour,
  minute,
  second,
}: {
  timeZone: string
  year: number
  month: number
  day: number
  hour: number
  minute: number
  second: number
}): Date {
  const date = new Date(Date.UTC(year, month, day, hour, minute, second))

  const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }))
  const tzDate = new Date(date.toLocaleString('en-US', { timeZone }))
  const offset = utcDate.getTime() - tzDate.getTime()

  date.setTime(date.getTime() + offset)
  return date
}

export function getNowInTimeZone({ timeZone }: { timeZone: string }): Date {
  const now = new Date()
  const tzDate = new Date(now.toLocaleString('en-US', { timeZone }))
  const offset = now.getTime() - tzDate.getTime()
  now.setTime(now.getTime() - offset)
  return now
}
